import './index.css';
import App from './App';
import React from 'react';
import { store } from './app/store';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { checkLanguage } from "./app/language/Language";
import '@fontsource/dm-sans';
import { createTheme, ThemeProvider } from '@mui/material';
const theme = createTheme({
    palette: {
        primary: {
            main: '#FFF',
            contrastText: '#21333B' 
        },
        secondary: {
            main: '#21333B',
            contrastText: '#FFF'
        },
        text: {
            primary: '#FFF',
            secondary: '#1E353D'
        }
    },
    typography: {
        fontFamily: ['DM Sans', 'DanmarkURW', 'sans-serif'].join(',')
    },
});

store.dispatch(checkLanguage());

if (process.env.NODE_ENV !== "development") console.log = () => {};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <React.StrictMode>
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </ThemeProvider>
        </Provider>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
